import * as Bowser from 'bowser';
import { IDisallowedBrowsers } from '../interfaces/app-config.interface';

export default function checkBrowser(disallowedBrowsers: IDisallowedBrowsers = { check: {} }): void {
  const browser = Bowser.getParser(window.navigator.userAgent);

  if (browser.satisfies(disallowedBrowsers.check)) {
    window.location.href = '/outdated-browser.html?referrer=' + encodeURIComponent(window.location.href);
  }
}
